<!-- @format -->

<div class="unit-wrapper">
	<div class="unit-navigation">
		<img
			src="../../assets/back-arrow-icon.svg"
			alt="back navigation" />
		<div class="prev-page">Branch</div>
		<img
			src="../../assets/forward-arrow-icon.svg"
			alt="back navigation" />
		<div class="forward-page">Add a Branch</div>
	</div>
	<div class="card add-unit">
		<h1 class="section-title">Add a Branch</h1>
		<p class="subtext">Fill out branch details using the form below.</p>
		<form
			(ngSubmit)="
				addUnit()
			"
			#form="ngForm"
			style="margin-top: 2rem">
			<app-custom-dropdown
				*ngIf="currentRole === Roles.superAdmin"
				(setSelected)="setCompany($event)"
				[label]="'Account Holder Name'"
				[selectedItem]="selectedValues.company.companyName"
				[items]="companies"
				[disabled]="true" />

			<div class="dropdown-container">
				<app-custom-dropdown
					(setSelected)="setPlant($event)"
					style="flex: 1"
					[label]="'Client Name'"
					[selectedItem]="selectedValues.plant.plantName"
					[items]="plants"
					[disabled]="true" />
				<div class="unit-name">
					<label
						for="unit_name"
						class="custom-label required"
						>Branch Name</label
					>
					<input
						[(ngModel)]="unitName"
						type="text"
						class="custom-input"
						name="unit_name"
						id="unit_name" />
					<span
						*ngIf="!errorMessage.success"
						class="unit-error">
						<img
							class="unit-icon"
							src="../../assets/error-icon.svg"
							alt="dropdown icon" />
						<div class="unit-error-text">
							{{ errorMessage.message }}
						</div>
					</span>
				</div>
			</div>

			<div class="btn-group">
				<button
					class="btn-outline"
					(click)="transferData()">
					Cancel
				</button>
				<button
					[ngClass]="
						unitName.length === 0 ? 'btn-fill disabled' : 'btn-fill'
					"
					type="submit">
					Add Branch
				</button>
			</div>
		</form>
	</div>
</div>
<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
